import clsx from 'clsx'

function RatingPoint({ value, rating }: RatingPointProps) {
  return (
    <div
      className={clsx(
        'w-6 h-6 rounded-full relative hover:bg-gradient-to-b',
        value <= rating
          ? 'bg-gradient-to-b from-sbtviolet-500 to-sbtviolet-600'
          : value <= rating + 0.5
          ? 'bg-gradient-to-b from-sbtviolet-500 to-sbtviolet-600 after:block after:absolute'
          : 'border-2 border-sbtviolet-500 '
      )}
    ></div>
  )
}

interface RatingPointProps {
  value: number
  rating: number
}

export default RatingPoint
